export default "__VITE_ASSET__BWeHvO37__"